'use strict';

angular.module('app').service('Leads', function ($http) {
  this.query = () => $http.get('/api/leads').then(({ data }) => data);

  this.get = (id) => $http.get(`/api/leads/${id}`).then(({ data }) => data);
});
